import {
  GET_STAFFROLES, GET_STAFFROLES_COMPLETED, GET_STAFFROLES_FAILED,
  GET_INVENTORYTAKER, GET_INVENTORYTAKER_COMPLETED, GET_INVENTORYTAKER_FAILED,
  ADD_INVENTORYTAKER, ADD_INVENTORYTAKER_COMPLETED, ADD_INVENTORYTAKER_FAILED,
  UPDATE_INVENTORYTAKER, UPDATE_INVENTORYTAKER_COMPLETED, UPDATE_INVENTORYTAKER_FAILED,
  SEARCH_STAFF_ROLES, SEARCH_STAFF_ROLES_COMPLETED, SEARCH_STAFF_ROLES_FAILED,
} from './actions';
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  staffRolesLoading: false,
  staffRoles: [],
  staffRolesError: null,
  staffRoleLoading: false,
  staffRole: null,
  staffRoleError: null,
  addingStaffRole: false,
  updatingStaffRole: false,
  search: searchDefault,
};

const staffRoleReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_STAFF_ROLES: return handleSearch(state, 'search', action.payload);
    case SEARCH_STAFF_ROLES_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_STAFF_ROLES_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_STAFFROLES: {
      return {
        ...state,
        staffRolesLoading: true,
        staffRoles: [],
        staffRolesError: null,
      };
    }
    case GET_STAFFROLES_COMPLETED: {
      return {
        ...state,
        staffRolesLoading: false,
        staffRoles: action.payload.data,
      };
    }
    case GET_STAFFROLES_FAILED: {
      return {
        ...state,
        staffRolesLoading: false,
        staffRolesError: action.payload,
      };
    }
    case GET_INVENTORYTAKER: {
      return {
        ...state,
        staffRoleLoading: true,
        staffRole: null,
        staffRoleError: null,
      };
    }
    case GET_INVENTORYTAKER_COMPLETED: {
      return {
        ...state,
        staffRoleLoading: false,
        staffRole: action.payload,
      };
    }
    case GET_INVENTORYTAKER_FAILED: {
      return {
        ...state,
        staffRoleLoading: false,
        staffRoleError: action.payload,
      };
    }
    case ADD_INVENTORYTAKER: {
      return {
        ...state,
        addingStaffRole: true,
      };
    }
    case ADD_INVENTORYTAKER_COMPLETED: {
      return {
        ...state,
        addingStaffRole: false,
      };
    }
    case ADD_INVENTORYTAKER_FAILED: {
      return {
        ...state,
        addingStaffRole: false,
      };
    }
    case UPDATE_INVENTORYTAKER: {
      return {
        ...state,
        updatingStaffRole: true,
      };
    }
    case UPDATE_INVENTORYTAKER_COMPLETED: {
      return {
        ...state,
        updatingStaffRole: false,
      };
    }
    case UPDATE_INVENTORYTAKER_FAILED: {
      return {
        ...state,
        updatingStaffRole: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default staffRoleReducer;



// WEBPACK FOOTER //
// ./src/StaffRole/reducer.js